/**
 * Route for `igaming-bonus-cost-deduction-from-ngr-share`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingBonusCostDeductionFromNgrSharePage } from "../features/igaming-bonus-cost-deduction-from-ngr-share/IgamingBonusCostDeductionFromNgrSharePage";

export const igamingBonusCostDeductionFromNgrShareRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-bonus-cost-deduction-from-ngr-share",
	component: IgamingBonusCostDeductionFromNgrSharePage,
});

export default igamingBonusCostDeductionFromNgrShareRoute;
